export enum PAGE_NAMES {
  HOME = "",
  RESULTS = "results",
  HOTEL_RESULTS = "hotel_results",
  FLIGHTS_OF1_PAX_LOADING = "detailsloading",
  FLIGHTS_OF1_PAX = "details",
  FLIGHTS_OF2_PAX = "checkout_passengers",
  FLIGHTS_OF1_PAYMENT = "payment",
  FLIGHTS_OF2_PAYMENT = "checkout_payment",
  FLIGHTS_SUMMARY = "tripdetails",
  HOTEL_PAYMENT = "hotel_payment",
  HOTEL_PAX = "hotel_guests",
  PRIME_PAGE = "membership_page",
}

export enum PAGE_TRACKING {
  HOME = "home",
  FLIGHT_TAB = "flight_tab",
  HOTELS_TAB = "hotels_tab",
  DYNPACK_TAB = "dynpack_tab",
  FLIGHTS_RESULTS = "flights_results",
  HOTELS_RESULTS = "hotels_results",
  PAX_LOADING = "flights_pax_loading",
  FLIGHTS_PAX_PAGE = "flights_pax_page",
  FLIGHTS_PAY_PAGE = "flights_pay_page",
  HOTEL_PAX_PAGE = "hotels_pax_page",
  HOTEL_PAY_PAGE = "hotels_pay_page",
  DP_PAX_PAGE = "dynpack_pax_page",
  DP_PAY_PAGE = "dynpack_pay_page",
  FLIGHTS_SUMMARY = "flights_summary",
  FLIGHTS_ANCILLARIES_PAGE = "flights_ancillaries_page",
  ANCILLARIES_PAGE = "ancillaries_page",
  PRIME_PAGE = "flights_prime_fares",
}

const PAGE_NAME_TO_TRACKING: Record<string, string> = {
  [PAGE_NAMES.HOME]: PAGE_TRACKING.HOME,
  [PAGE_NAMES.RESULTS]: PAGE_TRACKING.FLIGHTS_RESULTS,
  [PAGE_NAMES.HOTEL_RESULTS]: PAGE_TRACKING.HOTELS_RESULTS,
  [PAGE_NAMES.FLIGHTS_OF1_PAX_LOADING]: PAGE_TRACKING.PAX_LOADING,
  [PAGE_NAMES.FLIGHTS_OF1_PAX]: PAGE_TRACKING.FLIGHTS_PAX_PAGE,
  [PAGE_NAMES.FLIGHTS_OF2_PAX]: PAGE_TRACKING.FLIGHTS_PAX_PAGE,
  [PAGE_NAMES.FLIGHTS_OF1_PAYMENT]: PAGE_TRACKING.FLIGHTS_PAY_PAGE,
  [PAGE_NAMES.FLIGHTS_OF2_PAYMENT]: PAGE_TRACKING.FLIGHTS_PAY_PAGE,
  [PAGE_NAMES.FLIGHTS_SUMMARY]: PAGE_TRACKING.FLIGHTS_SUMMARY,
  [PAGE_NAMES.HOTEL_PAX]: PAGE_TRACKING.HOTEL_PAX_PAGE,
  [PAGE_NAMES.HOTEL_PAYMENT]: PAGE_TRACKING.HOTEL_PAY_PAGE,
  [PAGE_NAMES.PRIME_PAGE]: PAGE_TRACKING.PRIME_PAGE,
};

const getLinkTab = (url: string): string => {
  return url.replace(window.location.origin, "").replaceAll("/", "");
};

export const getHomeTab = (
  flightUrl: string,
  hotelUrl: string,
  DPUrl: string,
): string => {
  const tab = getLinkTab(window.location.href);

  const flightTab = getLinkTab(flightUrl);
  const hotelTab = getLinkTab(hotelUrl);
  const DPTab = getLinkTab(DPUrl);

  switch (tab) {
    case flightTab:
      return PAGE_TRACKING.FLIGHT_TAB;
    case hotelTab:
      return PAGE_TRACKING.HOTELS_TAB;
    case DPTab:
      return PAGE_TRACKING.DYNPACK_TAB;
    case PAGE_NAMES.HOME:
      return PAGE_TRACKING.HOME;
    default:
      return window.location.href
        .replace(window.location.origin, "")
        .split("/")
        .filter((n) => n)
        .toString()
        .replace(",", "_");
  }
};

export const getTrackingCategoryName = (
  flightUrl,
  hotelUrl,
  DPUrl,
  hashFragment,
): string => {
  let trackingPage = getHashPage(hashFragment);
  if (trackingPage === PAGE_TRACKING.HOME) {
    trackingPage = getHomeTab(flightUrl, hotelUrl, DPUrl);
  }
  return trackingPage;
};

const getHashPage = (hashFragment?: string): string => {
  // Check if the hash is present (if not, we are in home)
  if (hashFragment) {
    const hasPage = hashFragment.split("/")[0];

    return PAGE_NAME_TO_TRACKING[hasPage] || hasPage;
  }

  // If there is no fragment, we are in "home" page
  return PAGE_TRACKING.HOME;
};
